(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5607],{

/***/ 27148:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/choosing-a-car/page/[page]",
      function () {
        return __webpack_require__(59476);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* reexport safe */ _cinch_nx_landing_feature_articles_sub_hub__WEBPACK_IMPORTED_MODULE_0__.x6; }
/* harmony export */ });
/* harmony import */ var _cinch_nx_landing_feature_articles_sub_hub__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24726);
var __N_SSG = true;



/***/ }),

/***/ 24726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x6": function() { return /* reexport */ ArticleSubHubFeature; }
});

// UNUSED EXPORTS: getStaticPathsGenerator, getStaticPropsGenerator

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var src = __webpack_require__(60782);
// EXTERNAL MODULE: ../../../libs/landing/ui/articles/src/index.ts + 2 modules
var articles_src = __webpack_require__(313);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 266 modules
var shared_src = __webpack_require__(2388);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 54 modules
var ui_src = __webpack_require__(83624);
// EXTERNAL MODULE: ../../../libs/landing/feature-articles-sub-hub/src/lib/articles-sub-hub.module.css
var articles_sub_hub_module = __webpack_require__(42073);
var articles_sub_hub_module_default = /*#__PURE__*/__webpack_require__.n(articles_sub_hub_module);
// EXTERNAL MODULE: ../../../libs/shared/analytics/src/index.ts + 26 modules
var analytics_src = __webpack_require__(40731);
// EXTERNAL MODULE: ../../../node_modules/next/router.js
var router = __webpack_require__(35837);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/shared/util/src/index.ts + 25 modules
var util_src = __webpack_require__(37479);
// EXTERNAL MODULE: ../../../node_modules/classnames/index.js
var classnames = __webpack_require__(95685);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../../node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(19601);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ../../../libs/landing/feature-articles-sub-hub/src/lib/components/article-card/article-card.module.css
var article_card_module = __webpack_require__(88007);
var article_card_module_default = /*#__PURE__*/__webpack_require__.n(article_card_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-articles-sub-hub/src/lib/components/article-card/article-card.tsx






const ArticleCard = ({ title ="" , image , date ="" , featured =false  })=>{
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("article", {
        className: classnames_default()((article_card_module_default()).root, {
            [(article_card_module_default()).topCard]: featured
        }),
        "data-featured": featured,
        "data-uid": title,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((article_card_module_default()).imageContainer, {
                    [(article_card_module_default()).featured]: featured
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: (article_card_module_default()).image,
                    alt: (image === null || image === void 0 ? void 0 : image.alt) ?? "",
                    src: (image === null || image === void 0 ? void 0 : image.filename) || `${ false ? 0 : "https://landing-articles.snc-prod.aws.cinch.co.uk"}/image-coming-soon.svg`,
                    layout: "responsive",
                    width: featured ? 400 : 250,
                    height: featured ? 253 : 158,
                    priority: featured
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        type: featured ? index_esm/* TextStyles.vehicleTitle */.k7.vehicleTitle : index_esm/* TextStyles.mainTitle */.k7.mainTitle,
                        element: "h3",
                        className: (article_card_module_default()).title,
                        lineHeight: "display",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                        dateTime: date,
                        className: (article_card_module_default()).date,
                        children: (0,util_src/* getDayMonthYearFormat */.Al)(date)
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/landing/feature-articles-sub-hub/src/lib/components/articles-cards-list/articles-cards-list.module.css
var articles_cards_list_module = __webpack_require__(86036);
var articles_cards_list_module_default = /*#__PURE__*/__webpack_require__.n(articles_cards_list_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-articles-sub-hub/src/lib/components/articles-cards-list/articles-cards-list.tsx






const ArticlesCardsList = ({ articles , path , page  })=>{
    const { isFallback  } = (0,router.useRouter)();
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const capitalPath = path.charAt(0).toUpperCase() + path.slice(1);
    const handleClick = (title)=>{
        trackEvent({
            eventName: `${capitalPath}- click article card`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: "link",
                    label: title,
                    action: analytics_src/* EventNames.click */.Vy.click
                }
            }
        });
    };
    if (isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "data-testid": "skeletonPlaceHolder",
            children: Array.from({
                length: 10
            }).map((_, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* HubCardSkeleton */.dL, {
                    featured: idx === 0,
                    hasDate: true
                }, idx))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        children: articles === null || articles === void 0 ? void 0 : articles.map((item, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: (articles_cards_list_module_default()).listItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: item.path,
                    className: (articles_cards_list_module_default()).link,
                    "aria-label": item.title,
                    onClick: ()=>handleClick(item.title),
                    "data-testid": "article-sub-hub-preview-card",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCard, {
                        title: item.title,
                        image: item.image,
                        date: item.date,
                        featured: idx === 0 && page === 1
                    })
                })
            }, item.title))
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-articles-sub-hub/src/lib/components/pagination/pagination.tsx



const Pagination = ({ path , currentPage , resultsPerPage =10 , total  })=>{
    const { isFallback  } = (0,router.useRouter)();
    if (isFallback) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Pagination */.tl, {
        totalItemsCount: total,
        activePage: currentPage,
        itemsCountPerPage: resultsPerPage,
        sourcePage: path,
        enabledLinks: true
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-articles-sub-hub/src/lib/components/index.ts



;// CONCATENATED MODULE: ../../../libs/landing/feature-articles-sub-hub/src/lib/articles-sub-hub.tsx







function ArticleSubHubFeature({ story , path , preview , generatedAt , currentPage , numberOfArticles , resultsPerPage , articles  }) {
    const { content  } = (0,src/* useStoryblokState */.f0)({
        story,
        enableBridge: preview
    });
    const { title , description  } = content ?? {
        title: "Loading",
        description: "Loading..."
    };
    const [SEO] = (content === null || content === void 0 ? void 0 : content.SEO) ?? [
        {}
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Head */.Fb, {
                ...SEO,
                generatedAt: generatedAt,
                fallbackTitle: "Cars Without The Faff - cinch",
                fallbackDescription: "Welcome to cinch, the faff free way to buy & sell cars. We have thousands of used cars, ready to be sold to you."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                className: (articles_sub_hub_module_default()).page,
                "data-testid": `articles-sub-hub-${path}`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* Wrapper */.im, {
                    isSlim: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(articles_src/* ArticleHeader */.K, {
                            title: title,
                            subTitle: description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlesCardsList, {
                            path: path,
                            articles: articles,
                            page: currentPage
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination, {
                            path: path,
                            currentPage: currentPage,
                            total: numberOfArticles,
                            resultsPerPage: resultsPerPage
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ../../../libs/core/datadog-server/src/index.ts + 7 modules
var datadog_server_src = __webpack_require__(86634);
;// CONCATENATED MODULE: ../../../libs/landing/feature-articles-sub-hub/src/lib/get-static-props.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ 

const instrumentedGetStoryBySlug = (0,datadog_server_src/* traceFunction */.KG)("getStoryBySlug", src/* getStoryBySlug */.OI);
const instrumentedGetStories = (0,datadog_server_src/* traceFunction */.KG)("getStories", src/* getStories */.EW);
function getStaticPropsGenerator({ subHubPath , resultsPerPage =10 , breadCrumbs =[] , generatePageBreadcrumb =false  }) {
    return async ({ preview =false , params  })=>{
        const version = preview ? "draft" : "published";
        const localBreadcrumbs = [
            ...breadCrumbs
        ];
        let currentPage = 1;
        try {
            if (typeof (params === null || params === void 0 ? void 0 : params.page) === "string") {
                if ((params === null || params === void 0 ? void 0 : params.page) === "1") {
                    // Redirect [sub-hub]/page/1 to [sub-hub]/
                    return {
                        redirect: {
                            permanent: true,
                            destination: `/${subHubPath}`
                        }
                    };
                } else {
                    currentPage = Number.parseInt(params.page);
                }
            }
            const [subHubStory, { articles , total: numberOfArticles  }] = await Promise.all([
                getSubHubStory({
                    subHubPath,
                    version
                }),
                getArticlesForPage({
                    subHubPath,
                    version,
                    perPage: resultsPerPage,
                    page: currentPage
                })
            ]);
            subHubStory.content.title = subHubStory.content.title || breadCrumbs[breadCrumbs.length - 1].text;
            if (generatePageBreadcrumb && currentPage !== 1) {
                localBreadcrumbs.push({
                    text: `Page ${currentPage}`,
                    url: `/${subHubPath}/page/${currentPage}`
                });
            }
            return {
                props: {
                    preview,
                    story: subHubStory,
                    path: subHubPath,
                    currentPage,
                    numberOfArticles,
                    resultsPerPage,
                    articles,
                    layoutProps: {
                        showBorderRadius: true,
                        breadCrumbs: localBreadcrumbs
                    },
                    generatedAt: Date.now()
                },
                revalidate: 60
            };
        } catch (error) {
            console.log(error);
            if (typeof error === "string" || error instanceof Error) {
                tagError(error);
            }
            return {
                notFound: true,
                revalidate: 60
            };
        }
    };
}
function toArticle(subhubPath) {
    return (input)=>({
            path: `/${subhubPath}/${input.slug}`,
            title: input.content.title,
            image: input.content.image,
            date: input.published_at ?? ""
        });
}
async function getSubHubStory({ subHubPath , version  }) {
    const story = await instrumentedGetStoryBySlug(`articles/hubs/${subHubPath}`, {
        version
    });
    if (!story || !story.content || story.content.component !== "ArticlesSubHubPage") {
        throw new Error(`Failed to load story for sub-hub ${subHubPath}`);
    }
    return story;
}
async function getArticlesForPage({ subHubPath , version , page , perPage  }) {
    const articleStories = await instrumentedGetStories({
        version,
        starts_with: `articles/${subHubPath}`,
        page,
        per_page: perPage,
        sort_by: "published_at:desc"
    }).catch(()=>({
            stories: [],
            total: 0
        }));
    if (articleStories.stories.length === 0) {
        throw new Error(`no articles available for "articles/${subHubPath}" page ${page}`);
    }
    return {
        articles: articleStories.stories.map(toArticle(subHubPath)),
        total: Number(articleStories.total)
    };
}

;// CONCATENATED MODULE: ../../../libs/landing/feature-articles-sub-hub/src/index.ts





/***/ }),

/***/ 313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* reexport */ ArticleHeader; },
  "T": function() { return /* reexport */ formatFullSlugToPath; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var src = __webpack_require__(60782);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 54 modules
var ui_src = __webpack_require__(83624);
// EXTERNAL MODULE: ../../../node_modules/next/router.js
var router = __webpack_require__(35837);
// EXTERNAL MODULE: ../../../node_modules/@mui/material/Skeleton/Skeleton.js + 12 modules
var Skeleton = __webpack_require__(78840);
// EXTERNAL MODULE: ../../../libs/landing/ui/articles/src/lib/components/header/header.module.css
var header_module = __webpack_require__(5300);
var header_module_default = /*#__PURE__*/__webpack_require__.n(header_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/articles/src/lib/components/header/header.tsx







const ArticleHeader = ({ title , subTitle , image , video  })=>{
    const { isFallback  } = (0,router.useRouter)();
    const prefersReducedMotion = (0,ui_src/* usePrefersReducedMotion */.Tb)();
    if (isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
            className: (header_module_default()).header,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    sx: {
                        marginBottom: "16px"
                    },
                    animation: prefersReducedMotion ? false : "wave",
                    variant: "rectangular",
                    width: 250,
                    height: 61
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    sx: {
                        marginBottom: "16px"
                    },
                    animation: prefersReducedMotion ? false : "wave",
                    variant: "rectangular",
                    width: 750,
                    height: 56
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: (header_module_default()).header,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (header_module_default()).title,
                "data-testid": "article-title",
                children: title
            }),
            subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (header_module_default()).subTitle,
                children: subTitle
            }),
            ((video === null || video === void 0 ? void 0 : video.length) ?? 0) <= 0 && (image === null || image === void 0 ? void 0 : image.filename) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* BaseCard */.bj, {
                className: (header_module_default()).imageWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: (0,src/* getStoryblokImageServiceUrl */.Vb)(image.filename, {
                        height: 639,
                        width: 960,
                        filters: [
                            {
                                quality: 80
                            }
                        ],
                        fitIn: {
                            width: 960,
                            height: 639
                        }
                    }),
                    alt: image.alt || "article hero"
                })
            }) : null
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/articles/src/lib/utils/format-full-slug-to-path/format-full-slug-to-path.ts
/**
 * This takes the `full_slug` string available in Storyblok story object
 * and formats it so it can be used as a pathname.
 * @param fullSlug i.e. 'articles/guides/choosing-a-car/[slug]'
 * @returns An internal pathname string i.e '/guides/choosing-a-car/[slug]'
 */ const formatFullSlugToPath = (fullSlug)=>`/${fullSlug.slice(fullSlug.indexOf("/") + 1)}`;

;// CONCATENATED MODULE: ../../../libs/landing/ui/articles/src/index.ts




/***/ }),

/***/ 42073:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"articles-sub-hub_page__6o1en"};

/***/ }),

/***/ 88007:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"article-card_root__CLHCT","title":"article-card_title__zvYlw","imageContainer":"article-card_imageContainer__X7t_e","featured":"article-card_featured__se9Vr","image":"article-card_image__wDxed","date":"article-card_date__BVPJJ"};

/***/ }),

/***/ 86036:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"articles-cards-list_link__xS2bP","listItem":"articles-cards-list_listItem__dDXp1"};

/***/ }),

/***/ 5300:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__bf1yM","title":"header_title__4GtYq","subTitle":"header_subTitle__1gtFs","video":"header_video__Fu0gh","imageWrapper":"header_imageWrapper__48_mj"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(27148); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);